import { Alert, Snackbar } from "@mui/material";
import theme from "../theme";
import { useWindowSize } from "@reactuses/core";

interface ToastMsgType {
  open: boolean;
  handleClose?: (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => void;
  content?: string;
}

const PopUpMsg: React.FC<ToastMsgType> = (props) => {
  const { open, handleClose, content } = props;
  const { width: widthData } = useWindowSize();

  return (
    <div>
      <Snackbar
        // 컨테이너 부분
        sx={
          widthData > theme.screen.md
            ? {
                width: "100%",
                height: "100vh",
                margin: "auto",
                zIndex: 80,
              }
            : {
                width: "100vw",
                height: "100vh",
                margin: "auto",
                zIndex: 80,
                left: 0,
              }
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        ContentProps={{
          sx: {
            textAlign: "center",
          },
        }}
        open={open}
        onClose={handleClose}
      >
        <Alert
          severity="warning"
          sx={
            widthData > theme.screen.md
              ? {
                  // 메시지 컨테이너 부분
                  backgroundColor: theme.color.pastelRed_500,
                  textAlign: "center",
                  height: "10%",
                  width: "70%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  "& .MuiAlert-message": {
                    // 메시지 부분
                    textAlign: "center",
                    color: theme.color.white,
                    fontWeight: 700,
                    fontSize: 15,
                  },

                  "& .MuiSvgIcon-root": {
                    // 아이콘 부분
                    fill: theme.color.white,
                    width: "20px",
                    height: "20px",
                  },
                }
              : {
                  // 메시지 컨테이너 부분
                  backgroundColor: theme.color.pastelRed_500,
                  textAlign: "center",
                  height: "10%",
                  width: "90%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: 0,

                  "& .MuiAlert-message": {
                    // 메시지 부분
                    textAlign: "center",
                    color: theme.color.white,
                    fontWeight: 700,
                    fontSize: 15,
                  },

                  "& .MuiSvgIcon-root": {
                    // 아이콘 부분
                    fill: theme.color.white,
                    width: "20px",
                    height: "20px",
                  },
                }
          }
        >
          {content}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default PopUpMsg;
